'use client';

import { useTranslations } from 'next-intl';

import type { DanceTemplate } from '@/config/dance-templates';
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
} from '@/shared/components/ui/dialog';

import { TemplateBrowser } from './template-browser';

interface TemplatePickerDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  onSelect: (template: DanceTemplate) => void;
  initialSubjectType?: string;
}

export function TemplatePickerDialog({
  open,
  onOpenChange,
  onSelect,
  initialSubjectType,
}: TemplatePickerDialogProps) {
  const t = useTranslations('common.uploader');

  const handleSelect = (template: DanceTemplate) => {
    onSelect(template);
    onOpenChange(false);
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-h-[85vh] overflow-y-auto sm:max-w-3xl">
        <DialogHeader>
          <DialogTitle>{t('choose_template')}</DialogTitle>
        </DialogHeader>
        <TemplateBrowser
          onSelect={handleSelect}
          size="sm"
          loadOnMount={open}
          initialSubjectType={initialSubjectType}
          emptyMessage="No templates found."
          loadMoreClassName="mt-6"
        />
      </DialogContent>
    </Dialog>
  );
}
